// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResultRow-cls1_TpD","cls2":"AutoCompleteResultRow-cls2_Gfq AutoCompleteResultRow-cls1_TpD","blue":"AutoCompleteResultRow-blue_SXk"};